import { useMapsLibrary } from '@vis.gl/react-google-maps';
import { useEffect, useMemo, useState } from 'react';

function useGoogleMapsGeocoder() {
  const [geocoder, setGeocoder] = useState(null);

  const GeocodingLibrary = useMapsLibrary('geocoding');
  const isGeocoderLoaded = useMemo(() => geocoder != null, [geocoder]);

  useEffect(() => {
    if (!GeocodingLibrary) return;
    const service = new GeocodingLibrary.Geocoder();

    if (service != null) {
      setGeocoder(service);
    }
  }, [GeocodingLibrary]);

  return {
    isGeocoderLoaded,
    geocoder,
  };
}

export { useGoogleMapsGeocoder };
